import React from "react";

import { useTranslation } from "utils";

import { AlertBanner, Flex, Form, KlimRadioGroup, Typography } from "components";

import { CROP } from "pages/app/all-field-view/constants/cropForm.ts";

export type SecondaryDataCropFormProps = {
  initialValue: boolean | null;
};

export const SecondaryDataCropForm = ({ initialValue }: SecondaryDataCropFormProps) => {
  const { t } = useTranslation("allFieldView");
  const form = Form.useFormInstance();
  const isSecondaryData = Form.useWatch([CROP, "isSecondaryData"], form);

  return (
    <Flex className="add-edit-crop-form">
      <div className="form-container" data-testid="add-edit-crop-form-secondary-data-widget">
        <Typography variant="h5">{t("cropForm.isSecondaryData.title")}</Typography>
        <Typography className="margin-top-200" variant="paragraph-m">
          {t("cropForm.isSecondaryData.question")}*
        </Typography>
        <Form.Item
          initialValue={initialValue}
          name={[CROP, "isSecondaryData"]}
          rules={[{ required: true, message: t("cropForm.isSecondaryData.errorMessage") }]}
        >
          <KlimRadioGroup
            buttonStyle="solid"
            className="radio-bg-white margin-top-150"
            dataTestId="is-secondary-data-toggle"
            fullWidth
            options={[
              // inverted: we store "isSecondaryData" but ask "can you document this?". This is the only place it gets inverted
              { value: false, label: t("yes") },
              { value: true, label: t("no") },
            ]}
            optionType="button"
            required
            size="large"
            type="tertiary"
          />
        </Form.Item>
        {/* only show the warning Alert to farmers who have explicitly chosen "No" */}
        {isSecondaryData === true ? (
          <AlertBanner
            className="margin-top-150"
            headingSize="paragraph-m"
            iconName="tabler/alert-triangle"
            iconAlign="start"
            isTitleBold
            title={t("cropForm.isSecondaryData.alertTitle")}
            description={t("cropForm.isSecondaryData.alertDescription")}
            type="warning"
          />
        ) : (
          <AlertBanner
            className="margin-top-150"
            headingSize="paragraph-m"
            iconName="tabler/bulb"
            iconAlign="start"
            isTitleBold
            title={t("cropForm.isSecondaryData.infoTitle")}
            description={t("cropForm.isSecondaryData.infoDescription")}
            type="recommended"
          />
        )}
      </div>
    </Flex>
  );
};
